import type { BudgetTrackingTraitModel } from 'modules/budgets/models/budgetTracking';

export const earliestAllowedDate = new Date('2010');
export const latestAllowedDate = new Date('2060');

export type EntityId = string;

export interface ValidatedEntity extends BudgetTrackingTraitModel.PostTrait {
  id: string;
  amount: number;
  currency: string;
  description: string;
  requesterId: string;
}

export interface Entity extends BudgetTrackingTraitModel.FetchedTrait {
  id: string;
  amount: number;
  currency: string;
  description: string;
  requesterId: string;
}
